export function reloadPage(): void {
  document.location.reload();
}
